import React, { Suspense } from 'react';
import { useUIStore } from '../../store';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { HeroSection } from './HeroSection';
import { Calculator } from '../calculator/Calculator';
import { ContactSection } from './ContactSection';
import { ErrorBoundary } from '../ErrorBoundary';

// Temporarily disable lazy loading for debugging - lazy load other components
// const Calculator = React.lazy(() => import('../calculator/Calculator').then(m => ({ default: m.Calculator })));
const Scenarios = React.lazy(() => import('../scenarios/Scenarios').then(m => ({ default: m.Scenarios })));
const MoonPhase = React.lazy(() => import('../moonphase/MoonPhase').then(m => ({ default: m.MoonPhase })));
const AIHub = React.lazy(() => import('../ai/AIHub').then(m => ({ default: m.AIHub })));
const ProFeatures = React.lazy(() => import('../pro/ProFeatures').then(m => ({ default: m.ProFeatures })));

export const MainContent: React.FC = () => {
  const { activeSection } = useUIStore();

  // Debug logging
  console.log('MainContent rendering with activeSection:', activeSection);

  const renderActiveSection = () => {
    console.log('renderActiveSection called with:', activeSection);
    
    switch (activeSection) {
      case 'calculator':
        console.log('Rendering calculator section');
        return (
          <>
            <HeroSection />
            <Calculator />
            <ContactSection />
          </>
        );
      case 'scenarios':
        return <Scenarios />;
      case 'timewheel':
        return <MoonPhase />;
      case 'ai':
        return <AIHub />;
      case 'pro':
        return <ProFeatures />;
      default:
        return (
          <>
            <HeroSection />
            <Calculator />
            <ContactSection />
          </>
        );
    }
  };

  return (
    <main className="flex-1 overflow-hidden">
      <div className="h-full">
        <Suspense 
          fallback={
            <div className="flex h-full items-center justify-center">
              <LoadingSpinner size="lg" />
            </div>
          }
        >
          <div className="h-full animate-in fade-in-0 duration-300">
            <ErrorBoundary
              fallback={
                <div className="flex h-full items-center justify-center p-8">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold text-red-600 mb-4">组件加载失败</h2>
                    <p className="text-slate-600 mb-4">当前组件无法正常显示，请刷新页面重试</p>
                    <button 
                      onClick={() => window.location.reload()} 
                      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                      刷新页面
                    </button>
                  </div>
                </div>
              }
            >
              {renderActiveSection()}
            </ErrorBoundary>
          </div>
        </Suspense>
      </div>
    </main>
  );
};